import { render, staticRenderFns } from "./helpOTP.vue?vue&type=template&id=0bf72633&scoped=true&lang=pug"
import script from "./helpOTP.vue?vue&type=script&lang=js"
export * from "./helpOTP.vue?vue&type=script&lang=js"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=0bf72633&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf72633",
  null
  
)

export default component.exports